import React, { useState, useEffect } from "react";
import {
  Header,
  Message,
  Label,
  Button,
  Segment,
  Divider,
  Input,
  Checkbox,
  Icon,
} from "semantic-ui-react";
import { Alert } from "rsuite";
import Moment from "react-moment";
import CanView from "../../../../role-based-access/CanView";
import { Link } from "react-router-dom";
import { getAwb } from "../../../../actions/orders";

import Newrefund from "./addrefund";
import Documents from "../../../../components/Documents";

import EcontValidator from "./econtAddressValidator";
import NextlevelValidator from "./nextlevelValidator";

import Parcelshops from "./parcelshops";

import CancelOrderModal from "./CancelOrderModal";
import ProductsList from "./ProductsList";
import AddProduct from "./AddProduct";
import ChangeLogs from "./ChangeLogs";
import {
  getOrderV2,
  addOrderProductV2,
  updateOrderV2,
  deleteOrderProductV2,
  orderActionV2,
  duplicateOrder,
  createInvoice,
  // splitOrder,
} from "../../../../actions/orders";
import CountryFilter from "../../../Filters/CountryFilter";
import WarehouseFilter from "../../../Filters/WarehouseFilter";
import Comments from "../../../Comments";
import Services from "./Services";
import { apiCall } from "../../../../services/api";
import EditInputField from "./editfield";
import DropDownField from "./dropdownFiled";

import { DatePicker } from "rsuite";
import CourierFilter from "../../../Filters/CourierFilter";

const statusColor = {
  New: "blue",
  "No goods": "orange",
  "Order Ready for picking": "teal",
  "Product Picking": "blue",
  Packed: "green",
  Draft: "yellow",
  "Not shipped": "olive",
  Canceled: "red",
  "In progress": "pink",
};

const Order = (props) => {
  const [order, setOrder] = useState(null);
  // const [isFormTouched, setFormTouched] = useState(false);
  const [showAddRefund, setRefundOpen] = useState(false);
  const [addProduct, setAddproduct] = useState(false);
  const [updateField, setShowUpdateField] = useState({
    name: null,
    value: null,
  });

  const [updatingSegment, setUpdatingSegment] = useState();
  const [isEcontValidator, setEcontValidatoOpen] = useState(false);
  const [validatingAddress, setValidatingaddress] = useState(false);
  const [isModalOpen, showCancelModal] = useState(false);
  const [creatingInvoice, setCreatingInvoice] = useState(false);
  const [showValidator, setShowValidator] = useState(false);

  const handleCheckCOD = (checked) => {
    setUpdatingSegment("payment");
    updateOrderV2({
      query: { "payment.COD.apply": checked },
      id: order._id,
    })
      .then((order) => {
        setOrder(order);
        setUpdatingSegment(null);
      })
      .catch((err) => setUpdatingSegment(null));
  };
  const handleIsCompany = (checked) => {
    setUpdatingSegment("address");
    updateOrderV2({
      query: { "shipping.shipTo.client.isCompany": checked },
      id: order._id,
    })
      .then((order) => {
        setOrder(order);
        setUpdatingSegment(null);
      })
      .catch((err) => setUpdatingSegment(null));
  };

  const handleOrderAction = (action) => {
    setUpdatingSegment("actions");
    if (action)
      orderActionV2({
        action,
        orderId: order._id,
      })
        .then((order) => {
          if (order.message) Alert.error(order.message);
          else setOrder(order);

          setUpdatingSegment(false);
        })
        .catch((err) => {
          Alert.error(err.message);
        });
    else setUpdatingSegment(false);
  };

  const handleSelectedParcelShop = (value) => {
    setUpdatingSegment("address");
    updateOrderV2({
      query: {
        "api_request.to_office": value ? 1 : 0,
        "api_request.office_code": value,
        // "api_request.name":name,
      },
      id: order._id,
    })
      .then((order) => {
        setOrder(order);
        setUpdatingSegment(null);
      })
      .catch((err) => setUpdatingSegment(null));
  };

  const handleUpdateField = (segment) => {
    setUpdatingSegment(segment);
    updateOrderV2({
      query: { [updateField.name]: updateField.value },
      id: order._id,
    })
      .then((order) => {
        setOrder(order);
        setUpdatingSegment(null);
      })
      .catch((err) => setUpdatingSegment(null));

    setShowUpdateField({ name: null, value: null });
  };

  const handleUpdateField_validator = ({ segment, query }) => {
    setUpdatingSegment(segment);
    updateOrderV2({
      query,
      id: order._id,
    })
      .then((order) => {
        setOrder(order);
        setUpdatingSegment(null);
      })
      .catch((err) => setUpdatingSegment(null));
  };

  const handleAddOrderProduct = (item) => {
    setUpdatingSegment("products");
    addOrderProductV2(order._id, item).then((order) => {
      setOrder(order);
      setUpdatingSegment(false);
    });
  };

  const validateOrder = (id) => {
    setValidatingaddress(true);
    getAwb(id)
      .then((resp) => {
        if (resp.status === "success") {
          Alert.success(`Tracking received:${resp.trackingId}`);
          setValidatingaddress(false);
        }
      })
      .catch((err) => setValidatingaddress(false));

    setTimeout(() => setValidatingaddress(false), 1000);
  };

  const handleDeleteItem = ({ itemId, name, sku, quantity }) => {
    setUpdatingSegment("products");
    deleteOrderProductV2({
      name,
      itemId,
      orderId: order._id,
      sku,
      quantity,
    }).then((order) => {
      setOrder(order);
      setUpdatingSegment(false);
    });
  };

  const duplicate = (id) => {
    setUpdatingSegment("actions");

    duplicateOrder(id).then((resp) => {
      setUpdatingSegment(false);
      window.open(`/orders/${resp._id}`);
    });
  };

  const split = (id) => {
    setUpdatingSegment("actions");

    const url = `${process.env.REACT_APP_API}/orders/${id}/split`;
    apiCall("get", url)
      
        .then((resp) => {
          Alert.success("Order Split succesfuly");
          setUpdatingSegment(false);
          setOrder(resp);
        })
        .catch((err) => {
          setUpdatingSegment(null);
          Alert.error(err.message);
        });
  };

  const handleInvoice = () => {
    setCreatingInvoice(true);
    createInvoice(props.match.params.id)
      .then((resp) => {
        setOrder(resp);
        setCreatingInvoice(false);
      })
      .catch((error) => Alert.error(error.message));
  };

  useEffect(() => {
    getOrderV2(props.match.params.id).then((resp) => setOrder(resp));
  }, [props.match.params.id]);

  if (!order) return <div>loading...</div>;

  return (
    <div className="flex--column" style={{ maxWidth: "900px", margin: "15px" }}>
      {order.errMsgs && order.errMsgs.length > 0 && (
        <Segment inverted color="red" name="errors">
          {order.errMsgs.map((item, index) => (
            <div className="alert alert-danger" key={index}>
              {item}
            </div>
          ))}
        </Segment>
      )}

      <segment name="header">
        <div className="flex--between vertical--center">
          <div style={{ marginTop: "10px", marginLeft: "0" }}>
            <Header className="form__header" as="h3">
              {" "}
              Order for shipment
              <Label color={statusColor[order.status]}>{order.status}</Label>
              <Header.Subheader>
                client # {order.clientOrderNr}
              </Header.Subheader>
              <Header.Subheader>
                internal # {order.internalNumericId}
              </Header.Subheader>
              {/* <span className="grey--text small--text">Order NR:</span>{" "} */}
            </Header>

            <div className="flex_spaceBetween"></div>

            <span className="grey--text small--text ">
              <Link
                to={`/businessclients/${
                  order.businessclient ? order.businessclient._id : ""
                }`}
              >
                {order.businessclient ? order.businessclient.name : ""}
              </Link>
            </span>
            {/* <span className="grey--text small--text  ml--2">
              created at:{" "}
              <Moment format="DD-MM-YY HH:mm">{order.createdAt}</Moment>
            </span> */}
          </div>

          {order.processing.instructions && (
            <Message warning size="big">
              <Message.Header>Packing Instructions!</Message.Header>
              <p>{order.processing.instructions}</p>
              <Label floating>
                {/* <button onClick={this.handleRemoveInstruction}>x</button> */}
              </Label>
            </Message>
          )}
        </div>
      </segment>

      <Segment name="actions" loading={updatingSegment == "actions"}>
        <div>
          <div
            className="flex--between"
            style={{ margin: "5px", rowGap: "8px" }}
          >
            <Button onClick={() => duplicate(order._id)}>Dublicate</Button>
            <Button onClick={() => split(order._id)} color="green">
              Split No Goods
            </Button>

            <CanView path="/orders/:id" action="refund">
              <Button onClick={() => setRefundOpen(true)}>Refund order</Button>
            </CanView>
            <CanView path="/orders/:id" action="pack">
              {["Product Picking"].includes(order.status) && (
                <Link to={`/packer/orders/${order._id}`}>
                  <Button>Pack Order</Button>
                </Link>
              )}
            </CanView>
            <CanView path="/orders/:id" action="update">
              {!["Draft"].includes(order.status) && (
                <Button
                  color="yellow"
                  onClick={() => handleOrderAction("Pause")}
                >
                  Pause/Draft
                </Button>
              )}
            </CanView>
            <CanView path="/orders/:id" action="update">
              {!["Product Picking"].includes(order.status) && (
                <Button
                  color="blue"
                  onClick={() => handleOrderAction("Picking")}
                >
                  Send for Picking
                </Button>
              )}
            </CanView>
            <CanView path="/orders/:id" action="update">
              <Button
                color="pink"
                onClick={() => handleOrderAction("Inprogress")}
              >
                Call later
              </Button>
            </CanView>

            <CanView path="/orders/:id" action="cancel">
              <Button color="red" onClick={() => showCancelModal(true)}>
                Cancel Order
              </Button>

              <CancelOrderModal
                handleOrderAction={(action) => {
                  showCancelModal(false);
                  handleOrderAction(action);
                }}
                isModalOpen={isModalOpen}
                handleCloseModal={() => showCancelModal(false)}
                _id={order._id}
              />
            </CanView>

            {/* <CanView path="/orders/:id" action="update">
              {isFormTouched && (
                <Button color="teal" onClick={this.handleUpdateOrder}>
                  Save updates
                </Button>
              )}
            </CanView> */}
          </div>
        </div>
      </Segment>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          columnGap: "20px",
          justifyContent: "space-between",
        }}
      >
        <Segment
          name="address"
          loading={updatingSegment == "address"}
          style={{ maxWidth: "440px", width: "440px", marginTop: "14px" }}
        >
          <div className="flex--between">
            <Header>Ship To Address</Header>
            <Button
              color="green"
              loading={validatingAddress}
              onClick={() => validateOrder(order._id)}
            >
              Validate Address{" "}
            </Button>
          </div>

          <Divider></Divider>
          <table>
            <tr id="codApply" style={{ height: "33px" }}>
              <td style={{ width: "120px", fontWeight: "bold" }}>Is Company</td>
              <td style={{ textAlign: "left", width: "150px" }}>
                <Checkbox
                  // toggle
                  name="shipping.shipTo.client.isCompany"
                  checked={order.shipping.shipTo.client.isCompany}
                  onChange={(e, { checked }) => {
                    handleIsCompany(checked);
                  }}
                />
              </td>
            </tr>
            {order.shipping.shipTo.client.isCompany && (
              <>
                <EditInputField
                  text="Company name"
                  name="shipping.shipTo.client.companyName"
                  value={order.shipping.shipTo.client.companyName}
                  updateField={updateField}
                  setShowUpdateField={setShowUpdateField}
                  handleUpdateField={handleUpdateField}
                  id="companyName"
                  updateFieldBlock="address"
                />
                <EditInputField
                  text="Tax Id (VAT)"
                  name="shipping.shipTo.client.taxId"
                  value={order.shipping.shipTo.client.taxId}
                  updateField={updateField}
                  setShowUpdateField={setShowUpdateField}
                  handleUpdateField={handleUpdateField}
                  id="taxId"
                  updateFieldBlock="address"
                />
                <EditInputField
                  text="Company Id"
                  name="shipping.shipTo.client.nr_reg_com"
                  value={order.shipping.shipTo.client.nr_reg_com}
                  updateField={updateField}
                  setShowUpdateField={setShowUpdateField}
                  handleUpdateField={handleUpdateField}
                  id="nr_reg_com"
                  updateFieldBlock="address"
                />
              </>
            )}
            <EditInputField
              text="First name"
              name="shipping.shipTo.client.firstName"
              value={order.shipping.shipTo.client.firstName}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="fistName"
              updateFieldBlock="address"
            />

            <EditInputField
              text="Last name"
              name="shipping.shipTo.client.lastName"
              value={order.shipping.shipTo.client.lastName}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="lastName"
              updateFieldBlock="address"
            />
            <EditInputField
              text="Email"
              name="shipping.shipTo.client.email"
              value={order.shipping.shipTo.client.email}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="email"
              updateFieldBlock="address"
            />

            <EditInputField
              text="Phone"
              name="shipping.shipTo.phone"
              value={order.shipping.shipTo.phone}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="phone"
              updateFieldBlock="address"
            />

            <tr id="country " style={{ height: "33px" }}>
              <td style={{ width: "100px", fontWeight: "bold" }}>Country</td>
              <td style={{ textAlign: "left" }}>
                {updateField.name === "shipping.shipTo.country" && (
                  <div>
                    <CountryFilter
                      style={{ maxWidth: "200px" }}
                      useFilter={false}
                      value={updateField.value}
                      handleChange={(value) => {
                        setShowUpdateField({ ...updateField, value });
                      }}
                    />
                  </div>
                )}
                {updateField.name !== "shipping.shipTo.country" &&
                  order.shipping.shipTo.country}
              </td>
              <td style={{ textAlign: "right", width: "150px" }}>
                {updateField.name === "shipping.shipTo.country" && (
                  <div>
                    <Button
                      size="mini"
                      basic
                      color="red"
                      onClick={() => {
                        setShowUpdateField({ name: null });
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="mini"
                      basic
                      color="green"
                      onClick={() => handleUpdateField("address")}
                    >
                      Save
                    </Button>
                  </div>
                )}

                {updateField.name !== "shipping.shipTo.country" && (
                  <Button
                    icon="edit"
                    basic
                    size="mini"
                    onClick={() => {
                      setShowUpdateField({
                        name: "shipping.shipTo.country",
                        value: order.shipping.shipTo.country,
                      });
                    }}
                  ></Button>
                )}
              </td>
            </tr>

            <EditInputField
              text="Province"
              name="shipping.shipTo.province"
              value={order.shipping.shipTo.province}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="province"
              updateFieldBlock="address"
            />

            <EditInputField
              text="City"
              name="shipping.shipTo.city"
              value={order.shipping.shipTo.city}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="city"
              updateFieldBlock="address"
            />
            <EditInputField
              text="District"
              name="shipping.shipTo.district"
              value={order.shipping.shipTo.district}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="district"
              updateFieldBlock="address"
            />
            <EditInputField
              text="Street"
              name="shipping.shipTo.street"
              value={order.shipping.shipTo.street}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="street"
              updateFieldBlock="address"
            />

            <EditInputField
              text="Street Nr."
              name="shipping.shipTo.streetNr"
              value={order.shipping.shipTo.streetNr}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="streetNr"
              updateFieldBlock="address"
            />

            <EditInputField
              text="Post code"
              name="shipping.shipTo.postcode"
              value={order.shipping.shipTo.postcode}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="postcode"
              updateFieldBlock="address"
              validate={false}
              showValidator={showValidator}
              setShowValidator={setShowValidator}
            />
          </table>

          {showValidator && (
            <NextlevelValidator
              country={order.shipping.shipTo.country}
              city={order.shipping.shipTo.city}
              showValidator={showValidator}
              setShowValidator={setShowValidator}
              handleUpdate={(data) => {
                const query = { "shipping.shipTo.postcode": data.post_code };

                console.log(query);
                handleUpdateField_validator({ segment: "address", query });
              }}
            ></NextlevelValidator>
          )}

          {order.shipping.courier &&
            (order.shipping.courier.name === "ECONT" ||
              order.shipping.courier.name === "ECONT_GR") && (
              <Segment
                name="econtValidator"
                loading={updatingSegment == "econtValidator"}
              >
                <button onClick={() => setEcontValidatoOpen(!isEcontValidator)}>
                  Econt validator
                </button>
                {isEcontValidator && (
                  <EcontValidator
                    country={order.shipping.shipTo.country}
                    oldCity={order.shipping.shipTo.city}
                    oldProvince={order.shipping.shipTo.province}
                    oldPostcode={order.shipping.shipTo.postcode}
                    oldStreet={order.shipping.shipTo.street}
                    oldStreetNr={order.shipping.shipTo.streetNr}
                    handleToggleModal={() =>
                      setEcontValidatoOpen(!isEcontValidator)
                    }
                    isEcontValidator={isEcontValidator}
                    selectedAddress={(data) => {
                      // console.log("CALL BACK DATA:", data);
                      const query = {
                        "shipping.shipTo.city": data.newCity,
                        "shipping.shipTo.province": data.newProvice,
                        "shipping.shipTo.postcode": data.newPostcode,
                        "shipping.shipTo.street": data.newStreet,
                        "shipping.shipTo.streetNr": data.newStreetNr,
                      };

                      handleUpdateField_validator({
                        segment: "address",
                        query,
                      });
                    }}
                  ></EcontValidator>
                )}

                <Parcelshops
                  country={order.shipping.shipTo.country}
                  courierId={order.shipping.courier._id || ""}
                  isOffice={
                    order.api_request && order.api_request.to_office === 1
                      ? true
                      : false
                  }
                  office={
                    order.api_request && order.api_request.office_code
                      ? order.api_request.office_code
                      : ""
                  }
                  selectedOffice={(data) => {
                    handleSelectedParcelShop(data);
                  }}
                ></Parcelshops>
              </Segment>
            )}
        </Segment>

        <Segment
          name="shipping"
          loading={updatingSegment == "shipping"}
          style={{ maxWidth: "440px" }}
        >
          <Header as="h3">Shipping data</Header>
          <Divider />

          <table>
            <EditInputField
              text="Shipping Cost"
              name="shipping.shippingCost"
              value={order.shipping.shippingCost}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="shippingCost"
              updateFieldBlock="shipping"
            />

            <DropDownField
              text="Warehouse"
              name="shipping.shipFrom"
              value={
                order.shipping.shipFrom && order.shipping.shipFrom.name
                  ? order.shipping.shipFrom.name
                  : ""
              }
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="warehouse"
              updateFieldBlock="shipping"
              object={
                <WarehouseFilter
                  useFilter={false}
                  defaultOpen={true}
                  multiple={false}
                  value={updateField.value}
                  handleChange={(value) => {
                    setShowUpdateField({
                      name: "shipping.shipFrom",
                      value,
                    });
                  }}
                ></WarehouseFilter>
              }
            />
            <DropDownField
              text="Courier"
              name="shipping.courier"
              value={
                order.shipping.courier && order.shipping.courier.name
                  ?(<a target ='_blank' href={`/couriers/${order.shipping.courier._id}`}>{order.shipping.courier.name}</a> )
                  : ""
              }
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="courier"
              updateFieldBlock="shipping"
              object={
                <CourierFilter
                  useFilter={false}
                  defaultOpen={true}
                  multiple={false}
                  value={updateField.value}
                  handleChange={(value) => {
                    setShowUpdateField({
                      name: "shipping.courier",
                      value,
                    });
                  }}
                ></CourierFilter>
              }
            />

            <tr id="deliveryDate" style={{ height: "33px" }}>
              <td style={{ width: "120px", fontWeight: "bold" }}>
                Delivery Date
              </td>
              <td style={{ textAlign: "left" }}>
                {updateField.name === "shipping.deliveryDate" && (
                  <div>
                    <DatePicker
                      style={{ width: "200px" }}
                      oneTap
                      // placeholder="select"
                      value={updateField.value}
                      format="DD-MM-YYYY"
                      // ranges={[dateFrom,dateTo]}
                      onChange={(value) =>
                        setShowUpdateField({
                          name: "shipping.deliveryDate",
                          value,
                        })
                      }
                    />
                  </div>
                )}
                {updateField.name !== "shipping.deliveryDate" &&
                  order.shipping.deliveryDate && (
                    <div>
                      <Moment
                        //  className="small--text"
                        format="DD-MM-YY HH:mm"
                        style={{ display: "block" }}
                      >
                        {order.shipping.deliveryDate}
                      </Moment>
                    </div>
                  )}
              </td>
              <td style={{ textAlign: "right", width: "150px" }}>
                {updateField.name === "shipping.deliveryDate" && (
                  <div>
                    <Button
                      size="mini"
                      basic
                      color="red"
                      onClick={() => {
                        setShowUpdateField({ name: null });
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="mini"
                      basic
                      color="green"
                      onClick={() => handleUpdateField("shipping")}
                    >
                      Save
                    </Button>
                  </div>
                )}

                {updateField.name !== "shipping.deliveryDate" && (
                  <Button
                    icon="edit"
                    basic
                    size="mini"
                    onClick={() => {
                      setShowUpdateField({
                        name: "shipping.deliveryDate",
                        value: order.shipping.deliveryDate,
                      });
                    }}
                  ></Button>
                )}
              </td>
            </tr>

            <EditInputField
              text=" AWB (courierId)"
              name="shipping.trackingId"
              value={order.shipping.trackingId}
              updateField={updateField}
              setShowUpdateField={setShowUpdateField}
              handleUpdateField={handleUpdateField}
              id="trackingId"
              updateFieldBlock="shipping"
              link={order.shipping.tracking_awbPdf}
            />

            <tr id="Tracking" style={{ height: "33px" }}>
              <td style={{ width: "120px", fontWeight: "bold" }}>Tracking</td>
              <td style={{ textAlign: "left" }}>
                <a href={order.shipping.trackingUrl} target="_blank">
                  view
                </a>
              </td>
            </tr>
            <tr id="weight" style={{ height: "33px" }}>
              <td style={{ width: "120px", fontWeight: "bold" }}>Weight (g)</td>
              <td style={{ textAlign: "left" }}>{order.shipping.weight}</td>
            </tr>
          </table>
        </Segment>

        <Segment
          name="products"
          loading={updatingSegment == "products"}
          style={{
            maxWidth: "900px",
            width: "100%",
          }}
        >
          <div className="flex--between">
            <Header>Products</Header>
            <Button basic onClick={() => setAddproduct(!addProduct)}>
              {addProduct ? "Hide" : "Add"}
            </Button>
          </div>

          <Divider></Divider>
          {addProduct && (
            <AddProduct
              country={order.shipping.shipTo.country}
              handleAddProduct={(item) => handleAddOrderProduct(item)}
              businessclient={order.businessclient._id}
              warehouse={
                order.shipping.shipFrom ? order.shipping.shipFrom._id : null
              }
            />
          )}
          <ProductsList
            orderId={props.match.params.id}
            items={order.items}
            handleDeleteItem={handleDeleteItem}
          />
        </Segment>

        <Segment
          style={{ maxWidth: "450px", width: "440px" }}
          name="payment"
          loading={updatingSegment == "payment"}
        >
          <Header as="h3">Payment</Header>
          <Divider />

          <table>
            <tr id="paymentStatus" style={{ height: "33px" }}>
              <td style={{ width: "120px", fontWeight: "bold" }}>Status</td>
              <td style={{ textAlign: "left" }}>
                {updateField.name === "payment.status" && (
                  <div>
                    <Input
                      value={updateField.value}
                      style={{ height: "25px" }}
                      onChange={(e, { value }) => {
                        setShowUpdateField({ ...updateField, value });
                      }}
                    ></Input>
                  </div>
                )}
                {updateField.name !== "payment.status" && order.payment.status}{" "}
              </td>
              <td style={{ textAlign: "right", width: "150px" }}>
                {updateField.name === "payment.status" && (
                  <div>
                    <Button
                      size="mini"
                      basic
                      color="red"
                      onClick={() => {
                        setShowUpdateField({ name: null });
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="mini"
                      basic
                      color="green"
                      onClick={() => handleUpdateField("payment")}
                    >
                      Save
                    </Button>
                  </div>
                )}

                {updateField.name !== "payment.status" && (
                  <Button
                    icon="edit"
                    basic
                    size="mini"
                    onClick={() => {
                      setShowUpdateField({
                        name: "payment.status",
                        value: order.payment.status,
                      });
                    }}
                  ></Button>
                )}
              </td>
            </tr>
            <tr id="paymentType" style={{ height: "33px" }}>
              <td style={{ width: "120px", fontWeight: "bold" }}>Type</td>
              <td style={{ textAlign: "left" }}>{order.payment.type}</td>
            </tr>

            <tr id="codApply" style={{ height: "33px" }}>
              <td style={{ width: "120px", fontWeight: "bold" }}>COD apply</td>
              <td style={{ textAlign: "left", width: "150px" }}>
                <Checkbox
                  // toggle
                  name="codApply"
                  checked={order.payment.COD.apply}
                  onChange={(e, { checked }) => {
                    handleCheckCOD(checked);
                  }}
                />
              </td>
            </tr>

            {order.payment.COD.apply && (
              <tr id="codAmount" style={{ height: "33px" }}>
                <td style={{ width: "120px", fontWeight: "bold" }}>
                  COD amount
                </td>
                <td style={{ textAlign: "left" }}>
                  {updateField.name === "payment.COD.amount" && (
                    <div>
                      <Input
                        value={updateField.value}
                        style={{ height: "25px" }}
                        onChange={(e, { value }) => {
                          setShowUpdateField({ ...updateField, value });
                        }}
                      ></Input>
                    </div>
                  )}
                  {updateField.name !== "payment.COD.amount" &&
                    order.payment.COD.amount}{" "}
                  {order.payment.COD.amount != order.payment.COD.amountInit && (
                    <div>(Initial amount: {order.payment.COD.amountInit})</div>
                  )}
                </td>
                <td style={{ textAlign: "right", width: "150px" }}>
                  {updateField.name === "payment.COD.amount" && (
                    <div>
                      <Button
                        size="mini"
                        basic
                        color="red"
                        onClick={() => {
                          setShowUpdateField({ name: null });
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        size="mini"
                        basic
                        color="green"
                        onClick={() => handleUpdateField("payment")}
                      >
                        Save
                      </Button>
                    </div>
                  )}

                  {updateField.name !== "payment.COD.amount" && (
                    <Button
                      icon="edit"
                      basic
                      size="mini"
                      onClick={() => {
                        setShowUpdateField({
                          name: "payment.COD.amount",
                          value: order.payment.COD.amount,
                        });
                      }}
                    ></Button>
                  )}
                </td>
              </tr>
            )}
          </table>
        </Segment>

        <Segment
          name="invoice"
          style={{ maxWidth: "450px", width: "440px" }}
          loading={creatingInvoice}
        >
          {order.invoice && (
            <div className="flex--between">
              <div className="flex--left">
                <Header as="h3">Invoice</Header>
                <Link
                  to={`/invoices/${order.invoice._id}`}
                  target="_blank"
                  style={{ marginLeft: "10px" }}
                >
                  {order.invoice.sequenceNumber
                    ? order.invoice.sequenceNumber
                    : "DRAFT"}
                </Link>{" "}
              </div>
              <Link to={`/invoices/${order.invoice._id}/pdf`} target="_blank">
                <Icon name="file pdf" />
              </Link>
            </div>
          )}
          <Divider />

          {!order.invoice && (
            <Button basic onClick={() => handleInvoice()}>
              Generate New Invoice
            </Button>
          )}

          {order.invoice && (
            <>
              <div>
                {order.invoice.creditNote && (
                  <div>
                    CreditNote: {order.invoice.creditNote.sequenceNumber}
                  </div>
                )}
              </div>
              <p>Netto Total: {order.invoice.NETTO_total}</p>
              <p>VAT Total: {order.invoice.VAT_total}</p>
              <p>BRUTTO Total: {order.invoice.BRUTTO_total}</p>
            </>
          )}
          <div></div>

          {order.print && order.print.length > 0 && (
            <div style={{ marginTop: "10px" }}>
              <Header as="h3">For Print</Header>
              <Divider />

              {order.print.map((item, index) => (
                <li>
                  {item.name ? item.name : index} - <a href={item.url}>view</a>
                </li>
              ))}
            </div>
          )}
        </Segment>

        <CanView path="/billing" action="view">
          <Segment name="services" style={{ width: "440px" }}>
            {" "}
            <Services services={order.services}></Services>{" "}
          </Segment>
        </CanView>
        <div
          name="messages"
          style={{ marginTop: "14px", width: "900px" }}
          loading={updatingSegment == "messsages"}
        >
          <Comments
            trigger={"Order"}
            triggerId={props.match.params.id}
          ></Comments>
        </div>
        <Documents
          style={{ maxWidth: "900px", width: "900px" }}
          businessclient={order.businessclient._id}
          trigger="Order"
          triggerId={order._id}
        ></Documents>
        <Segment name="logs" style={{ maxWidth: "900px", width: "900px" }}>
          <ChangeLogs changeLogs={order.changeLogs} />
        </Segment>
        <Newrefund
          order={order}
          show={showAddRefund}
          closeModal={() => setRefundOpen(false)}
        ></Newrefund>
      </div>
    </div>
  );
};

export default Order;
